module.exports = __webpack_public_path__ + "static/wsu-ui.41f5b12f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/projects/wsu-library/wsu-ui.jpg
// module id = 484
// module chunks = 262546004982204